import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@components/Button";
import { Modal } from "@components/Modal/Modal";
import { useApiErrorUtils } from "@hooks/useApiErrorUtils";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useAcquireConsentMutation } from "@services/budget/mutations";

interface IPowerOfAttorneyBudgetToolsOfferModalProps extends IUseModalProps {
  ledgerConsentId: number;
}

export const PowerOfAttorneyBudgetToolsOfferModal: React.FC<
  IPowerOfAttorneyBudgetToolsOfferModalProps
> = (props) => {
  const { ledgerConsentId, ...rest } = props;
  const modal = useModal(rest);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { mutateAsync, isPending } = useAcquireConsentMutation();

  const { toastApiError } = useApiErrorUtils();

  const handleClose = () => {
    navigate("/bills");
    modal.close();
  };

  const handleSubmit = async () => {
    const response = await mutateAsync({ ledgerConsentId }).catch(
      toastApiError,
    );

    if (response) {
      toast.success(t("powerOfAttorney.budgetToolsOfferModal.toast.success"));
      navigate("/budget");
      modal.close();
    }
  };

  return (
    <Modal
      modal={modal}
      title={t("powerOfAttorney.budgetToolsOfferModal.title")}
      subtitle={t("powerOfAttorney.budgetToolsOfferModal.subtitle")}
      className="md:max-w-2xl"
      actionButtons={
        <React.Fragment>
          <Button variant="secondary" onClick={handleClose} className="w-full">
            {t("powerOfAttorney.budgetToolsOfferModal.buttons.cancel")}
          </Button>
          <Button
            className="w-full"
            onClick={handleSubmit}
            isLoading={isPending}
          >
            {t("powerOfAttorney.budgetToolsOfferModal.buttons.submit")}
          </Button>
        </React.Fragment>
      }
    ></Modal>
  );
};
